<template>
  <cs-view single-view>
    <template #content>
      <div style="min-height: 837px">
        <page-loading-animation
          :displayed="pageLoadingAnimationDisplayed()"
        ></page-loading-animation>
        <div class="mt-15">
          <div
            v-show="showError || (!isAuthenticated && !isInitClientConfigInProgress)"
            class="mt-15"
          >
            <v-row>
              <v-col class="main-title">Excursions</v-col>
            </v-row>
            <v-row class="mt-2 mb-3">
              <v-col>
                <span id="labelNotAuthorizedToViewExcursions"
                  >You are not authorized to view Excursions, please provide a correct auth
                  token.</span
                >
              </v-col>
            </v-row>
          </div>
          <form
            v-show="!showError && isAuthenticated && !isInitClientConfigInProgress"
            id="form"
            class="mt-15"
          >
            <v-card>
              <div class="excursions-content-padding">
                <div class="excursions-navigator">
                  <cs-button
                    v-if="excursionExportButtonDisplayed && 0 === active"
                    id="export-excursions"
                    class="safe-update-provider"
                    name="export-excursions"
                    testing-id="export-excursions"
                    label="EXPORT EXCURSIONS"
                    @click="excursionExportDialogDisplayed = true"
                  ></cs-button>
                  <div v-if="active === 0" class="update-providers-margin">
                    <update-providers :button-update-providers-enabled="true"></update-providers>
                  </div>
                </div>
                <div class="create-new-client-button-clear"></div>
                <excursion-list
                  v-if="0 === active"
                  :excursion-template-flag="false"
                ></excursion-list>
                <excursion-list
                  v-if="1 === active"
                  :excursion-template-flag="true"
                ></excursion-list>
              </div>
            </v-card>
            <cs-form-dialog
              id="dlg-export-excursion"
              v-model="excursionExportDialogDisplayed"
              heading="Export Excursions"
              body-id="excursionExportDialog"
              :primary-action="{ label: 'Export', eventName: 'primary-click' }"
              :secondary-action1="{
                label: 'Cancel',
                eventName: 'secondary1-click'
              }"
              @primary-click="excursionExport"
              @secondary1-click="excursionExportDialogDisplayed = false"
            >
              <template #cs-form-dialog-content>
                <v-card-text>Select export excursions date range:</v-card-text>
                <v-row class="export-format-container">
                  <v-col cols="3" class="export-format-label"> Start Date </v-col>
                  <v-col cols="9" class="export-format-label">
                    <v-text-field
                      id="excursion-export-start-date-input"
                      v-model="excursionExportStartDate"
                      variant="solo"
                      density="comfortable"
                      placeholder="DD/MM/YYYY"
                      class="export-date-input"
                      :error-messages="excursionExportStartDateErrors"
                      required
                      @update:model-value="v$.excursionExportStartDate.$touch()"
                      @blur="v$.excursionExportStartDate.$touch()"
                      @keyup="excursionExportStartDateInputChange"
                    />
                  </v-col>
                </v-row>
                <v-row class="export-format-container">
                  <v-col cols="3" class="export-format-label"> End Date </v-col>
                  <v-col cols="9" class="export-format-label">
                    <v-text-field
                      id="excursion-export-end-date-input"
                      v-model="excursionExportEndDate"
                      variant="solo"
                      density="comfortable"
                      placeholder="DD/MM/YYYY"
                      class="export-date-input"
                      :error-messages="excursionExportEndDateErrors"
                      required
                      @update:model-value="v$.excursionExportEndDate.$touch()"
                      @blur="v$.excursionExportEndDate.$touch()"
                      @keyup="excursionExportEndDateInputChange"
                    />
                  </v-col>
                  <div
                    v-if="excursionExportErrorMessageDisplay"
                    class="v-messages theme--light text-error excursions-not-found-message"
                  >
                    No excursion found in this date range. Please select alternative dates and try
                    again.
                  </div>
                </v-row>
                <v-card-text>Select export file format:</v-card-text>
                <v-row no-gutters align="center" class="export-format-container">
                  <v-col cols="12">
                    <v-checkbox
                      id="jsonFormatCheckbox"
                      v-model="jsonFormatTicked"
                      class="export-format-checkbox"
                      label="Json Format"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters align="center" class="export-format-container">
                  <v-col cols="12">
                    <v-checkbox
                      id="csvFormatCheckbox"
                      v-model="csvFormatTicked"
                      class="export-format-checkbox"
                      label="CSV Format"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </template>
            </cs-form-dialog>
          </form>
        </div>
      </div>
    </template>
  </cs-view>
</template>

<script>
import * as types from '@/store/mutationTypes';
import { CSBase } from '@complispace/cs-design-system';
import { mapState } from 'vuex';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import PageLoadingAnimation from './PageLoadingAnimation';
import UpdateProviders from './UpdateProviders';
import ExcursionList from './ExcursionList';

export default {
  name: 'EntityManagement',

  components: {
    PageLoadingAnimation,
    UpdateProviders,
    ExcursionList
  },

  extends: CSBase,

  props: [],

  setup: () => ({ v$: useVuelidate() }),

  data() {
    return {
      active: 0,
      excursionExportDialogDisplayed: false,
      jsonFormatTicked: false,
      csvFormatTicked: true,
      excursionExportStartDate: '',
      excursionExportEndDate: '',
      excursionExportErrorMessageDisplay: false
    };
  },

  validations() {
    return {
      excursionExportStartDate: {
        required,
        minValue: (value) => {
          const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
          if (!pattern.test(value)) {
            return false;
          }
          const startDate = new Date(value.replace(pattern, '$3-$2-$1'));
          return startDate > new Date('1900-01-01');
        },
        maxValue: (value) => {
          const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
          if (!pattern.test(value)) {
            return false;
          }
          const startDate = new Date(value.replace(pattern, '$3-$2-$1'));
          return startDate <= new Date();
        }
      },
      excursionExportEndDate: {
        required,
        minValue: (value) => {
          const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
          if (!pattern.test(value)) {
            return false;
          }
          const endDate = new Date(value.replace(pattern, '$3-$2-$1'));
          return endDate > new Date('1900-01-01');
        },
        maxValue: (value) => {
          const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
          if (!pattern.test(value)) {
            return false;
          }
          const endDate = new Date(`${value.replace(pattern, '$3-$2-$1')} 00:00:00`);
          let today = new Date();
          const dd = String(today.getDate()).padStart(2, '0');
          const mm = String(today.getMonth() + 1).padStart(2, '0');
          const yyyy = today.getFullYear();
          today = `${yyyy}-${mm}-${dd}`;

          return endDate <= new Date(`${today} 23:59:59`);
        }
      }
    };
  },
  computed: {
    ...mapState({
      isAuthenticated: (state) => state.authorisation.isAuthenticated,
      isInitClientConfigInProgress: (state) => state.authorisation.isInitClientConfigInProgress,
      excursionExportButtonDisplayed: (state) => state.common.excursionExportButtonDisplayed,
      clientsTabDisplayed: (state) => state.common.clientsTabDisplayed,
      clientUsersTabDisplayed: (state) => state.common.clientUsersTabDisplayed,
      usersTabDisplayed: (state) => state.common.usersTabDisplayed,
      showError: (state) => state.common.showError || false
    }),
    excursionExportStartDateErrors() {
      const errors = [];
      if (!this.v$.excursionExportStartDate.$dirty) return errors;
      if (this.v$.excursionExportStartDate.required.$invalid) {
        errors.push('Excursion Export Start Date is required.');
        return errors;
      }
      if (
        this.v$.excursionExportStartDate.minValue.$invalid ||
        this.v$.excursionExportStartDate.maxValue.$invalid
      ) {
        errors.push('Excursion Export Start Date is not valid.');
      }

      return errors;
    },
    excursionExportEndDateErrors() {
      const errors = [];

      if (!this.v$.excursionExportEndDate.$dirty) return errors;
      if (this.v$.excursionExportEndDate.required.$invalid) {
        errors.push('Excursion Export End Date is required.');
        return errors;
      }
      if (
        this.v$.excursionExportEndDate.minValue.$invalid ||
        this.v$.excursionExportEndDate.maxValue.$invalid
      ) {
        errors.push('Excursion Export End Date is not valid.');
      }

      return errors;
    }
  },
  watch: {
    $route(to) {
      if (`${to.name}` === 'Excursions') {
        this.active = 0;
        if (Object.keys(to.query).length === 0) {
          window.location.reload();
        }
      } else if (`${to.name}` === 'Templates') {
        this.active = 1;
        if (Object.keys(to.query).length === 0) {
          window.location.reload();
        }
      }
    },
    jsonFormatTicked(newVal) {
      this.csvFormatTicked = !newVal;
    },
    csvFormatTicked(newVal) {
      this.jsonFormatTicked = !newVal;
    }
  },
  async mounted() {
    const excludedAttributeList = [
      'excursionAdditionalInformationEnabled',
      'vendorExcursionSidInputEnabled',
      'providerUpdateActionEnabled',
      'clientUsersTabDisplayed',
      'usersTabDisplayed',
      'clientsTabDisplayed',
      'clientSiteSettingsButtonDiplayed',
      'clientSelfGroupManagementDisplayed',
      'publicSchoolFeatureSetEnabled',
      'riskCategoryManagementMenuItemDisplayed',
      'operationManagementMenuItemDisplayed',
      'studentManagementSubjectManagementDisplayed',
      'userDisplayName',
      'userEmail'
    ];
    const argHash = {
      excludedAttributeList,
      storeModuleName: ''
    };
    this.$store.commit(types.COMMON_RESET_STORE_MODULE_STATE, argHash);

    const route = this.$route;
    if (route) {
      if (`${route.name}` === 'Excursions') {
        this.active = 0;
      } else if (`${route.name}` === 'Templates') {
        this.active = 1;
      } else {
        this.active = 0;
      }
      const { axiosInstance, eventPluginCommonAdapter, stbApiAdapter } = this.$app;
      await this.$store.dispatch('authorisation/validateAndSetUserTokenOrLogout', {
        query: this.$route.query,
        axiosInstance
      });
      await this.$store.dispatch('common/initClientConfig', {
        eventPluginCommonAdapter,
        stbApiAdapter
      });
    }
  },
  methods: {
    pageLoadingAnimationDisplayed() {
      let loadingAnimationDisplayed = false;

      if (this.isInitClientConfigInProgress) {
        loadingAnimationDisplayed = true;
      }

      return loadingAnimationDisplayed;
    },
    async excursionExport() {
      this.v$.excursionExportStartDate.$touch();
      this.v$.excursionExportEndDate.$touch();

      if (
        this.excursionExportStartDateErrors.length !== 0 ||
        this.excursionExportEndDateErrors.length !== 0
      ) {
        return;
      }
      const excursionCommonAdapter = new this.$app.excursionCommon.Adapter({
        store: this.$store,
        app: this.$app
      });

      const filterParam = {
        'start-date': this.formatDateString(this.excursionExportStartDate),
        'end-date': this.formatDateString(this.excursionExportEndDate)
      };

      if (this.csvFormatTicked) {
        filterParam.format = 'csv';
        const { excursionsNotFound, message } =
          await excursionCommonAdapter.exportExcursionsWithCSVFormat(filterParam, this.$store);
        if (message) {
          this.showErrorAlert(message, true);
        } else if (excursionsNotFound) {
          this.excursionExportErrorMessageDisplay = true;
          setTimeout(() => {
            this.excursionExportErrorMessageDisplay = false;
          }, 5000);
        } else {
          this.excursionExportDialogDisplayed = false;
        }
      } else {
        filterParam.format = 'json';
        const { excursionsNotFound, message } =
          await excursionCommonAdapter.exportExcursionsWithJSONFormat(filterParam, this.$store);
        if (message) {
          this.showErrorAlert(message, true);
        } else if (excursionsNotFound) {
          this.excursionExportErrorMessageDisplay = true;
          setTimeout(() => {
            this.excursionExportErrorMessageDisplay = false;
          }, 5000);
        } else {
          this.excursionExportDialogDisplayed = false;
        }
      }
    },
    excursionExportStartDateInputChange(e) {
      if (e.key === 'Backspace' || e.key === 'Delete') return;

      if (
        Number.isNaN(parseInt(String(e.key), 10)) ||
        String(this.excursionExportStartDate).length >= 11
      ) {
        this.excursionExportStartDate = String(this.excursionExportStartDate).substring(0, 10);
      }
      if (
        String(this.excursionExportStartDate).length === 2 ||
        String(this.excursionExportStartDate).length === 5
      ) {
        this.excursionExportStartDate += '/';
      }
    },
    excursionExportEndDateInputChange(e) {
      if (e.key === 'Backspace' || e.key === 'Delete') return;

      if (
        Number.isNaN(parseInt(String(e.key), 10)) ||
        String(this.excursionExportStartDate).length >= 11
      ) {
        this.excursionExportStartDate = String(this.excursionExportStartDate).substring(0, 10);
      }
      if (
        String(this.excursionExportEndDate).length === 2 ||
        String(this.excursionExportEndDate).length === 5
      ) {
        this.excursionExportEndDate += '/';
      }
    },
    formatDateString(dateString) {
      const year = String(dateString).split('/')[2];
      const month = String(dateString).split('/')[1];
      const day = String(dateString).split('/')[0];
      return `${year}-${month}-${day}`;
    }
  }
};
</script>
<style scoped>
.update-providers-margin {
  display: block;
  margin-left: auto;
  float: right;
}
.update-providers-margin button {
  margin-right: 0;
}

.export-format-label {
  display: flex;
  align-items: center;
}
.export-format-container {
  margin: 0 0.5rem;
}
.excursions-export-link {
  padding: 0 0.5rem;
  padding-bottom: 13px;
  cursor: pointer;
}
.excursions-not-found-message {
  margin-top: 0px;
  text-align: center;
}
.home_main_container {
  position: relative;
}
.left_menu_container {
  background-color: #2f4051;
  height: 100%;
}
.client-admin-setting-section-title {
  font-weight: bold;
}
</style>
